export interface HttpRetryOptions {
  maxAttempts: number;
  baseDelayMs: number;
  backoffMultiplier: number;
  jitterMs: number;
}

export const DEFAULT_HTTP_RETRY_OPTIONS: HttpRetryOptions = {
  maxAttempts: 3,
  baseDelayMs: 500,
  backoffMultiplier: 2,
  jitterMs: 100,
};
